import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from "@angular/core";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { MatAccordion } from "@angular/material/expansion";
import { ScreenUtilsService } from "core/services";
import { Subject, filter, map, take } from "rxjs";
import { UserDetailService } from "../user-detail.service";
import { UserSplugConfigService } from "./user-splug-config.service";

@Component({
  selector: 'ss-user-splug-config',
  templateUrl: './user-splug-config.component.html',
  styleUrls: ['./user-splug-config.component.scss'],
  providers: [UserSplugConfigService],
  host: {
    class: 'display-block full-stretch'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserSplugConfigComponent implements OnInit {

  private readonly _destroy = new Subject<void>();

  @ViewChild('accordion')
  private _accordion: MatAccordion

  readonly accordionSubject = this._userSplugConfigService.accordionSubject;

  readonly splugParametersConfigurationsSubject = this._userSplugConfigService.splugParametersConfigurationsSubject
  get splugParametersConfigurations() {
    return this.splugParametersConfigurationsSubject.value
  }

  readonly splugFormGroup = this._userSplugConfigService.splugFormGroup;
  readonly splugDefinitionsSubject = this._userSplugConfigService.splugDefinitionsSubject;

  readonly splugDefinitionsWithActionParamsObs = this.splugDefinitionsSubject.pipe(
    filter(Boolean),
    map((splugDefinitions) => splugDefinitions.filter(({ controls }) => Boolean(controls)))
  )

  get tabsHeader() {
    return this._userDetailService.tabsHeader
  }

  get header() {
    return this._userDetailService.header
  }

  get baseElement() {
    return this._userDetailService.baseElement
  }


  readonly validationResultSubject = this._userSplugConfigService.validationResultSubject;
  readonly validSplugsObs = this._userSplugConfigService.validSplugsObs;
  readonly selectedSplugsSubject = this._userSplugConfigService.selectedSplugsSubject;

  get selectedSplugs() {
    return this.selectedSplugsSubject.value
  }
  get userId() {
    return this._userSplugConfigService.userId;
  }

  readonly errorSplugObs = this.validationResultSubject.pipe(
    filter(Boolean),
    map((validationResult) => Object.entries(validationResult).filter(([_, { status }]) => status !== 'OK')),
    map((invalidResults) => invalidResults.reduce<{ [splugId: string]: boolean }>((total, [splugId]) => ({ ...total, [splugId]: true }), {}))
  )


  readonly isLargeScreenObs = this._screenUtilsService.isLargeScreenObs
  readonly isSmallerScreenObs = this._screenUtilsService.isSmallerScreenObs;

  constructor(
    private readonly _userSplugConfigService: UserSplugConfigService,
    private readonly _userDetailService: UserDetailService,
    private readonly _screenUtilsService: ScreenUtilsService
  ) {

  }

  ngOnInit(): void {

  }

  append(element: HTMLElement) {

    return this._userDetailService.append(element)
  }

  ngAfterViewInit() {

    this.accordionSubject.next(this._accordion);

  }

  toggleSelectedSplug(event: MatCheckboxChange, splugId: string) {
    const checked = event.checked;

    if (checked) {
      this._userSplugConfigService.selectSplug(splugId)
      return
    }

    this._userSplugConfigService.deselectSplug(splugId);
  }

  save() {
    this._userSplugConfigService.validateAndSave().pipe(take(1)).subscribe();
  }

  reset() {
    this._userSplugConfigService.reset();
  }

  validate() {
    return this._userSplugConfigService.validate().pipe(take(1)).subscribe();
  }

}
